import styles from './styles.module.scss';
import TechnicalSkillsList from './TechnicalSkillsList/TechnicalSkillsList';

const TechnicalSkills = () => (
  <div className={styles.container}>
    <TechnicalSkillsList />
  </div>
);

export default TechnicalSkills;
